import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import _ from 'lodash';
import TermDefinitionsDetails from './TermDefinitionsDetails';
import TermDefinitionsPassages from './TermDefinitionsPassages';
import TermDefinitionsResources from './TermDefinitionsResources';
import './TermDefinitions.css';
import { Button } from 'react-bootstrap';
import Collapse from 'react-bootstrap/Collapse';
import { getUniquePropIds } from '../../common/utils';
import TermRelatedDefEtymologies from '../TermEtymology/TermRelatedDefEtymologies';
import { useKmap } from '../../../hooks/useKmap';
import TermDefinitions from './TermDefinitions';
import { getAllDefs } from '../TermsInfo';
import TermDictionaries from '../TermDictionaries';

export const TermVariantDefinitions = ({ variant }) => {
    const [open, setOpen] = useState(false);
    const vid = variant.related_terms_id_s;

    const {
        isLoading: isKmapLoading,
        data: kmapData,
        isError: isKmapError,
        error: kmapError,
    } = useKmap(vid, 'info');

    if (isKmapLoading) {
        return null;
    }

    const [definitions, otherDefinitions] = getAllDefs(kmapData);
    //console.log("definitions", Array(definitions));
    // console.log("otherDefinitions", otherDefinitions);
    if (
        Object.keys(definitions).length === 0 &&
        Object.keys(otherDefinitions).length === 0
    ) {
        return null;
    }

    const verb = open ? 'Hide' : 'View';

    return (
        <>
            <div className="d-inline-block">
                (
                <a
                    onClick={() => setOpen(!open)}
                    aria-controls="variant-defs"
                    aria-expanded={open}
                    className="d-inline-block font-90"
                >
                    {verb} definitions
                </a>
                )
            </div>
            <div className="container">
                <Collapse in={open}>
                    <div id="variant-defs" className="card">
                        <div className="px-2 py-0">
                            <TermDefinitions
                                mainDefs={definitions['main_defs']}
                                kmRelated={[]}
                            />
                            <TermDictionaries
                                definitions={otherDefinitions}
                                kmapData={kmapData}
                            />
                        </div>
                    </div>
                </Collapse>
            </div>
        </>
    );
};
